module.exports = __webpack_public_path__ + "img/t.66d58f12.svg";